var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubClearIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5,
    r: 12,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2928 15.4999L9.31299 20.4797L10.0201 21.1868L14.9999 16.207L19.9797 21.1868L20.6868 20.4797L15.707 15.4999L20.6868 10.5201L19.9797 9.81299L14.9999 14.7928L10.0201 9.81299L9.31299 10.5201L14.2928 15.4999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubClearIc);
export default __webpack_public_path__ + "static/media/subClear_ic.e346fbb2b852c5a43dce74f05f8329b5.svg";
export { ForwardRef as ReactComponent };